















































import { Component, Vue } from "vue-property-decorator";
import CButton from "../../basics/buttons/CButton.vue";
import NoteBox from "../../basics/boxes/NoteBox.vue";
import UploadCsvFile, {
  UploadEvent
} from "../../components/inputs/UploadCsvFile.vue";
import SimpleAlert from "@/basics/alerts/SimpleAlert.vue";
import {
  createGroupUsers,
  InputError
} from "@/graphql/mutation/createGroupUsers";
import { downloadAsFile } from "@/lib/download";
import LabelInputText from "@/components/inputs/LabelInputText.vue";
import { createUser } from "@/graphql/mutation/createUser";
import LabelTitle from "@/basics/inputs/LabelTitle.vue";

@Component({
  components: {
    CButton,
    UploadCsvFile,
    NoteBox,
    SimpleAlert,
    LabelInputText,
    LabelTitle
  }
})
export default class UsersNew extends Vue {
  errors: InputError[] = [];
  checkToken = "ユーザー名,権限,メールアドレス";
  name: string = "";
  email: string = "";
  isGroupAdmin: boolean = false;
  btnStatus: boolean = false;

  get isIE(): boolean {
    const ua: string = window.navigator.userAgent.toLowerCase();
    if (ua.match(/trident\/7/)) {
      return true;
    }
    return false;
  }

  /* 単体 */
  async click() {
    this.btnStatus = true;
    const name = this.name.trim();
    const email = this.email.trim();
    const isGroupAdmin = this.isGroupAdmin;
    const groupId = this.$route.params.groupId;

    // バリデーション
    if (!name) {
      alert("ユーザー名を入力してください");
      this.btnStatus = false;
      return;
    }

    if (isGroupAdmin) {
      if (!email) {
        alert("メールアドレスを入力してください");
        this.btnStatus = false;
        return;
      }
    }

    try {
      const result = await createUser(this.$apollo, {
        name,
        email,
        groupId,
        isGroupAdmin
      });

      alert("登録しました");

      // TODO: rawResultの型対応
      if(!result.data) throw new Error("データが取得できませんでした")
      const rawResult: any = result.data.createUser;
      const csvData = [
        rawResult.name,
        rawResult.role,
        rawResult.email,
        rawResult.loginId,
        rawResult.password
      ];

      const csv = `${this.checkToken},ログインID,パスワード\r\n${csvData}\r\n`;
      downloadAsFile("group-users-password.csv", "text/csv", csv);
      this.$router.push({ name: "group-users", params: { groupId: groupId } });
    } catch {
      this.btnStatus = false;
      alert("ユーザー作成に失敗しました");
    }
  }

  /* CSVアップロード */
  async upload({ text }: UploadEvent) {
    const groupId = this.$route.params.groupId;
    const result = await createGroupUsers(this.$apollo, {
      groupId,
      input: text!
    });
    if (result.errors) {
      this.errors = result.errors || [];
      alert("登録できませんでした");
      return;
    }

    alert("登録しました");

    const csv = `${this.checkToken},ログインID,パスワード
${result
  .data!.map(d => [d.name, d.role, d.email, d.loginId, d.password].join(","))
  .join("\r\n")}
`;
    downloadAsFile("group-users-password.csv", "text/csv", csv);
    this.$router.push({
      name: "group-users",
      params: { groupId: groupId }
    });
  }

  parseCheckError() {
    alert(
      `CSV読み込みに失敗しました。「${this.checkToken}」を確認できませんでした。`
    );
  }
}
